import {AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {GuiService} from "../../../services/gui.service";
import {ServerService} from "../../../services/server.service";
import {DxDataGridComponent} from "devextreme-angular";
import {DxService} from "../../../services/dx.service";
import {ActivatedRoute} from "@angular/router";
import {ProdottoVariante} from "../../../models/ProdottoVariante";
import {DialogService} from "../dialog/dialog.service";
import {DataService} from "../../../services/data.service";

@Component({
   selector: 'app-tab-taglie',
   templateUrl: './tab-taglie.component.html',
   styleUrls: ['./tab-taglie.component.scss']
})
export class TabTaglieComponent implements OnInit, AfterViewInit {
   @ViewChild('gridInstances') gridInstances!:DxDataGridComponent
   @Input() prodottoId;

   private _pvariant;
   @Input()
   set pVariant(value: ProdottoVariante[]) {
      this._pvariant = value;
      console.log(value);
   }
   get pVariant(): ProdottoVariante[] {
      return this._pvariant;
   }

   @Input() pVarianteId;
   @Input() varianteExist = false;
   @Input() tabs;

   public vendorSlug;
   public countTable:number = 0
   public isInit = false;

   constructor(private guiSrv:GuiService,
               private serverSrv:ServerService,
               private route: ActivatedRoute,
               private dataSrv: DataService,
               private dialogSrv: DialogService,
               private dxSrv:DxService) {
      this.route.pathFromRoot[3].params.subscribe(res => {
         this.vendorSlug = res.esercizio_slug
      })
   }

   ngOnInit(): void {}

   ngAfterViewInit(): void {

      if (this.prodottoId){
         this.dxSrv.initGrid(this.gridInstances, {}).then(() => {
         setTimeout(() => {
            this.refreshGridLayout();
            this.isInit = true;
         }, 300);
      });


         let url = this.vendorSlug ?
            `/api/esercizi/${this.vendorSlug}/prodotti/${this.prodottoId}/p_variant_instances` :
            `/api/prodotti/${this.prodottoId}/p_variant_instances`
         if (this.pVarianteId) url = this.vendorSlug ?
            `/api/esercizi/${this.vendorSlug}/prodotti/${this.prodottoId}/productvariants/${this.pVarianteId}/p_variant_instances` :
            `/api/prodotti/${this.prodottoId}/productvariants/${this.pVarianteId}/p_variant_instances`

         this.dxSrv.gridCreateDataSource(url, this.gridInstances,
            {
               onLoaded: rawData => {
                  this.countTable = rawData.initialCount
               },
               update: (key: any, values: any) => {
                  let url = this.vendorSlug ? `/api/esercizi/${this.vendorSlug}/prodotti/${this.prodottoId}/p_variant_instances/${key}` : `/api/prodotti/${this.prodottoId}/p_variant_instances/${key}`
                  this.serverSrv.put(url, values).then(res => {
                     this.gridInstances.instance.refresh()
                  }).catch(err => {
                     this.dialogSrv.showError({title: "Modifica taglia", err: err})
                  })
               }
            })
      }
      else
         this.isInit = true;
   }

   public refreshGridLayout() {
      this.dxSrv.fixGridLayout(this.gridInstances);
   }

   clickCreateTaglie() {
      this.guiSrv.showLoading()
      let url = `/api/prodotti/${this.prodottoId}/p_variant_instances/create`
      this.serverSrv.post(url).then(res => {
         this.guiSrv.hideLoading()
         this.gridInstances.instance.refresh()
      }).catch(err => {
         console.error(err)
         this.guiSrv.hideLoading()
      })
   }

   clickEliminaTaglia(id) {

   }

   clickChangeTab() {
      this.tabs.selectedIndex = 1
   }

}
